<template>
  <transition name="fade">
    <div class="c-login d-flex align-items-center pb-5 pt-5" v-if="showComponent">
      <div class="container d-flex flex-column align-items-center">
        <img class="c-login__brand mb-5" src="https://www.soleol.ch/assets/img/logo.svg" />
        <div class="row w-100">
          <div class="c-login__info col d-none d-md-flex flex-column justify-content-center">
            <h3 class="w-100">Notre soleil, un potentiel<br>énergétique sans limites</h3>
            <h6 class="w-100">Cet espace est exclusivement réservé aux clients de Soleol</h6>
          </div>
          <div class="c-login__form col pl-4 pr-4 pb-5 pt-3">
            <span class="c-login__form-title text-center mt-3 mb-3">votre compte</span>

              <login /> <!-- Component Login -->

          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
	import Login from './Login.vue'

	export default {
    components: { Login },
    data() {
      return {
        showComponent: false
      }
    },
    mounted() {
      setTimeout(() => {
        this.showComponent = true
      }, 1000)
    }
	}
</script>

<style>
  .fade-enter-active{
    transition: all .5s ease-out;
  }
  .fade-enter{
    opacity: 0;
    filter: blur(3px);
  }
</style>





// WEBPACK FOOTER //
// src/components/login/Welcome.vue